import intlTelInput from 'intl-tel-input';

export default context => {
    $('.intl-phone-input', context).each(function () {
        const $this = $(this)
        const options = {
            utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.19/js/utils.min.js',
            initialCountry: $this.data('phone-country') || "",
            nationalMode: false,
            separateDialCode: true,
            autoPlaceholder: "off"
        }
        if ($this.data('dropdown') !== 'default' && $this.closest('.windows').length > 0) {
            options.dropdownContainer = $this.closest('.windows')[0]
        }
        if ($this.data('input')) {
            options.hiddenInput = $this.data('input')
        }
        if ($this.data('phone-country')) {
            options.preferredCountries = [$this.data('phone-country')]
        }
        intlTelInput(this, options);
    })
}
